import { SubHeading as BaseSubHeading } from '../../common/forms/FormElements';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';

export const SubHeading = ({ onIntersect, id, ...restProps }) => {
    const { ref } = useIntersectionObserver({
        threshold: 0.5,
        onChange: (isIntersecting) => isIntersecting && onIntersect && onIntersect(id),
    });

    return (
        <div
            id={id}
            ref={ref}
            className="mb-2 mt-4"
        >
            <BaseSubHeading
                {...restProps}
            />
        </div>
    );
};

export default SubHeading;